import create from "zustand";

const store = (set) => ({
  interactiveConfig: null,
  isPageLoading: true,
  isAssetsUploading: false,
  setAssetLoadingState: (isAssetsUploading) => set({ isAssetsUploading }),
  setEngineLoadingState: (isPageLoading) => set({ isPageLoading }),
  setinteractiveConfig: (interactiveConfig) => set({ interactiveConfig }),
  showNotify: false,
  notifyMessage: null,
  setNotifyMessage: ({ showNotify, notifyMessage }) =>
    set({ showNotify, notifyMessage }),
});
export const useEngineStore = create(store);
export const engineStore = useEngineStore.getState;
